// extracted by mini-css-extract-plugin
export default {"root":"BusinessConfiguration_root__MJAUU","heading":"BusinessConfiguration_heading__gVPkr"};